import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';

const App: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);
  
  useEffect(() => {
    // Kullanıcı tercihlerini kontrol et
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode) {
      setDarkMode(JSON.parse(savedMode));
    } else {
      // Varsayılan olarak kullanıcının işletim sistemi tercihine bak
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setDarkMode(prefersDark);
    }
  }, []);

  return (
    <Router>
      <div className={darkMode ? 'dark-mode' : 'light-mode'}>
        <div className={`flex flex-col min-h-screen ${darkMode ? 'bg-neutral-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
          <Routes>
            <Route path="/" element={<LandingPage darkMode={darkMode} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App; 